<template>
    <el-dialog
        title="专家"
        :visible.sync="isVisible"
        :close-on-click-modal="false"
    >
        <el-form
            :model="form"
            label-position="top"
            ref="form"
        >
            <el-form-item label="封面">
                <ox-uploader
                    :drag="false"
                    accept=".jpg,.png,.jpeg"
                    list-type="picture-card"
                    category-id="5d328aa48a379854a4b52c84"
                    :file-list="form.avatar?[form.avatar]:[]"
                    @success="onCoverUploaded"
                    @remove="onCoverRemoved"
                />
            </el-form-item>
            <el-row :gutter="15">
                <el-col :span="20">
                    <el-form-item label="名称">
                        <el-input
                            v-model="form.name"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="优先级">
                        <el-checkbox v-model="form.top">置顶</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="15">
                <el-col :span="20">
                    <el-form-item label="领域">
                    <ox-select
                    schema="domain"
                    label-field="name"
                    v-model="form.domain"
                    :query="domainQuery"
                    style="width: 100%"
                />
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="状态">
                        <el-checkbox v-model="form.is_available">可约见</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="15">
                <el-col :span="12">
                    <el-form-item label="电话">
                        <el-input
                            v-model="form.phone"
                            autocomplete="off"
                            style="width: 100%"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="邮箱">
                        <el-input
                            v-model="form.email"
                            autocomplete="off"
                            style="width: 100%"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="一句话介绍">
                <el-input
                    v-model="form.brief"
                    autocomplete="off"
                    style="width: 100%"
                ></el-input>
            </el-form-item>
            <el-form-item label="个人简介">
                <ox-editor
                    category-id="5d33dfa39d8c9c7516b9004d"
                    v-model="form.description"
                />
            </el-form-item>
            <el-form-item label="技术研究">
                <ox-editor
                    category-id="5d33dfa39d8c9c7516b9004d"
                    v-model="form.research"
                />
            </el-form-item>
        </el-form>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                @click="hide"
                round
            >取 消</el-button>
            <el-button
                type="primary"
                @click="save"
                round
                :loading="isProcessing"
            >确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import OxUploader from "../../ox/components/form/OxUploader";
import OxSelect from "../../ox/components/form/OxSelect";
import OxEditor from "../../ox/components/form/OxEditor";

export default {
    name: "DemandFormDialog",
    components: {
        OxSelect,
        OxUploader,
        OxEditor
    },
    computed: {
        domainQuery() {
            const query = new window.BaaS.Query();
            query.compare("category", "=", "specialist");
            return query;
        }
    },
    data: function() {
        return {
            isProcessing: false,
            isVisible: false,
            form: {
                id: null,
                avatar: null,
                name: null,
                domain: null,
                brief: null,
                phone: null,
                email: null,
                description: null,
                research: null,
                is_available: true,
                top: false
            }
        };
    },
    methods: {
        reset() {
            this.form = {
                id: null,
                avatar: null,
                name: null,
                domain: null,
                brief: null,
                phone: null,
                email: null,
                description: null,
                research: null,
                is_available: true,
                top: false
            };
        },
        show(data = null) {
            if (data) {
                this.form = {
                    id: data.id,
                    avatar: data.avatar,
                    name: data.name,
                    domain: data.domain.id,
                    brief: data.brief,
                    phone: data.phone,
                    email: data.email,
                    description: data.description,
                    research: data.research,
                    is_available: data.is_available,
                    top: data.top
                };
                if (this.form.avatar) {
                    this.form.avatar.url = this.form.avatar.path;
                }
            } else {
                this.reset();
            }
            this.isVisible = true;
        },
        hide() {
            this.isVisible = false;
        },
        onCoverUploaded(resp, file) {
            this.form.avatar = file;
        },
        onCoverRemoved() {
            this.form.avatar = null;
        },
        save() {
            this.isProcessing = true;
            this.$ox
                .service("specialist")
                .save(this.form)
                .then(res => {
                    this.$notify.success({
                        title: "操作成功",
                        message: `专家“${this.form.name}”已保存`
                    });
                    this.hide();
                    this.$refs.form.resetFields();
                    this.$refs.form.clearValidate();
                    this.$emit("success", res);
                })
                .catch(err => {
                    this.$emit("error", err);
                    this.$notify.error({
                        title: "操作失败",
                        message: "专家信息保存失败，请与系统维护人员联系"
                    });
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        }
    }
};
</script>

<style scoped>
</style>